import { Construction } from "lucide-react";

export default function Placeholder({ title, section, description }) {
    return (
        <div data-testid="placeholder-page" className="mx-auto max-w-2xl py-24 text-center">
            <div className="mx-auto mb-6 flex h-12 w-12 items-center justify-center rounded-full border border-neutral-200 bg-white text-neutral-500">
                <Construction size={18} strokeWidth={1.75} />
            </div>
            <div className="text-[11px] font-medium uppercase tracking-widest text-neutral-500">
                {section}
            </div>
            <h1 className="mt-2 text-3xl font-medium tracking-tight text-neutral-900">
                {title}
            </h1>
            <p className="mx-auto mt-3 max-w-md text-sm text-neutral-500 leading-relaxed">
                {description ??
                    "This page isn't available yet."}
            </p>
            <div
                data-testid="placeholder-badge"
                className="mt-8 inline-flex items-center rounded-full border border-neutral-200 bg-white px-3 py-1 text-[11px] font-medium uppercase tracking-widest text-neutral-500"
            >
                Coming soon
            </div>
        </div>
    );
}
